/**
 * Regeln fuer Freigeben/Ablehnen am Regiebericht (TQ #960, Patric 26.10.: mit Einwandfrist).
 * Das Backend (POST /documents/reports/accept|decline) und die ERP-Methode trb_rueckmeldung_setzen
 * erzwingen dasselbe serverseitig; hier nur, wann die Knoepfe sinnvoll sind (fail-closed).
 */
export const REASON_MIN = 3
export const REASON_MAX = 500

export function reasonValid(reason: string): boolean {
  const n = [...reason.trim()].length
  return n >= REASON_MIN && n <= REASON_MAX && !/[<>]/.test(reason)
}

/** Ende des Einwand-Tages (lokal); null bei fehlendem/unlesbarem Wert. */
function deadline(einwandBis?: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(einwandBis ?? '')
  if (!m) return null
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59)
}

/**
 * Knoepfe nur, wenn der Beleg freigegeben ist, noch keine Rueckmeldung vorliegt ("" – fehlt der
 * Schluessel, kennt ERPNext das Feld nicht) und die Einwandfrist laeuft. Ohne einwand_bis
 * (Zugang nicht gesetzt, TRB_RM_KEIN_ZUGANG) keine Knoepfe.
 */
export function canGiveFeedback(
  r: { status?: string; rueckmeldung?: string; einwand_bis?: string },
  now: Date = new Date(),
): boolean {
  if (r.status !== undefined && r.status.trim().toLowerCase() !== 'freigegeben') return false
  if (r.rueckmeldung !== '') return false
  const d = deadline(r.einwand_bis)
  return d !== null && now.getTime() <= d.getTime()
}

/** Kundentext zu einem fehlgeschlagenen Freigeben/Ablehnen; nie der Rohtext des Backends. */
export function feedbackErrorText(e: unknown, kind: 'accept' | 'decline'): string {
  const what = kind === 'accept' ? 'Die Freigabe' : 'Die Ablehnung'
  const status = (e as { response?: { status?: number } } | null)?.response?.status
  if (status === undefined) return `${what} konnte nicht gesendet werden. Bitte prüfen Sie Ihre Internetverbindung.`
  if (status === 400) return `${what} wurde nicht angenommen. Bitte prüfen Sie Ihre Eingabe.`
  if (status === 403) return 'Dafür fehlt Ihnen die Berechtigung.'
  if (status === 404) return 'Dieser Regiebericht ist nicht mehr verfügbar.'
  if (status === 409) return 'Zu diesem Regiebericht wurde bereits eine Rückmeldung abgegeben oder die Einwandfrist ist abgelaufen.'
  if (status === 502 || status === 503) return `${what} ist gerade nicht möglich. Bitte versuchen Sie es später noch einmal.`
  return `${what} konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.`
}
